import { render, staticRenderFns } from "./DocumentPreviewPublic.vue?vue&type=template&id=35c245e1&scoped=true&"
import script from "./DocumentPreviewPublic.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewPublic.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreviewPublic.vue?vue&type=style&index=0&id=35c245e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c245e1",
  null
  
)

export default component.exports